import { Component, forwardRef, input } from '@angular/core';
import { ToastSeverity } from './toast.interface';
import {
  BgColorDirective,
  TextColorDirective,
  ToastBodyComponent,
  ToastCloseDirective,
  ToastComponent,
  ToastHeaderComponent,
} from '@coreui/angular';

@Component({
  selector: 'app-toast-item',
  templateUrl: './toast-item.component.html',
  host: { '[class]': 'hostClasses()' },
  providers: [{ provide: ToastComponent, useExisting: forwardRef(() => ToastItemComponent) }],
  imports: [
    ToastHeaderComponent,
    ToastBodyComponent,
    ToastCloseDirective,
    BgColorDirective,
    TextColorDirective,
  ],
  standalone: true,
})
export class ToastItemComponent extends ToastComponent {
  readonly title = input('');
  readonly message = input('');
  readonly icon = input('');
  readonly severity = input<ToastSeverity | ''>('');
  readonly closeButton = input(true);
  readonly textColor = input('');
  readonly headerColor = input('');
  readonly headerTextColor = input('');
  readonly bodyTextColor = input('');
}
